import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Session } from '../../models/session.school.model';
import {
  SessionAdapter,
  SessionState,
} from '../reducers/session.school.reducer';
import { selectRouteParams } from './router.selector';

export const getSessionState = createFeatureSelector<SessionState>('sessions');
export const getIds = (state: SessionState) => state.ids;

export const {
  selectIds: getSessionIds,
  selectEntities: getSessionEntities,
  selectAll: getAllSessions,
  selectTotal: getTotalSessions,
} = SessionAdapter.getSelectors(getSessionState);

export const loading = createSelector(
  getSessionState,
  (state: SessionState) => state.loading,
);

export const inProgress = createSelector(
  getSessionState,
  (state: SessionState) => state.inProgress,
);

export const getSessionsByGroup = (
  groupId: string | null,
  academicYear: number | null | undefined,
) =>
  createSelector(getAllSessions, (allItems) => {
    if (allItems) {
      return allItems.filter((item) => {
        return item.groupId === groupId && item.academicYear === academicYear;
      });
    } else {
      return null;
    }
  });

export const getTeacherSessions = (
  teacherId: string,
  gradeId?: string,
  academicYear?: number,
) =>
  createSelector(getAllSessions, selectRouteParams, (allItems, { id }) => {
    if (allItems) {
      return allItems.filter((item) => {
        return (
          item.groupId === id &&
          item.academicYear === academicYear &&
          (item.teacherId === teacherId || item.gradeId === gradeId)
        );
      });
    } else {
      return null;
    }
  });

export const getSessionsCountByGroup = (
  groupId: string | null,
  academicYear: number | null | undefined,
) =>
  createSelector(getAllSessions, (allItems) => {
    if (!groupId || !academicYear) return 0;
    return allItems.filter((item) => {
      return item.groupId === groupId && item.academicYear === academicYear;
    }).length;
  });

export const getSessionById = (id: string) =>
  createSelector(getAllSessions, (allItems) => {
    if (allItems) {
      return allItems.find((item) => {
        return item.id === id;
      });
    } else {
      return null;
    }
  });

export const getSessionsByGradeId = (
  gradeId: string | null,
  groupId: string | null,
  academicYear: number | null | undefined,
) =>
  createSelector(getAllSessions, (allItems) => {
    if (!gradeId || !groupId || !academicYear) return [];
    return allItems
      .filter((item) => {
        return (
          item.gradeId == gradeId &&
          item.groupId === groupId &&
          item.academicYear === academicYear
        );
      })
      .sort(sortDescendingByStartDate);
  });

export const getSessionIdsByGroup = (groupId: string) =>
  createSelector(getAllSessions, (allItems) => {
    return allItems
      .filter((item) => item.groupId === groupId)
      .map((item) => item.id)
      .filter((item) => item != undefined);
  });

function sortDescendingByStartDate(a: Session, b: Session): number {
  return a.startDate > b.startDate ? -1 : a.startDate < b.startDate ? 1 : 0;
}
